export const CHANNEL_FETCH_LIST_BY_DEVICE = "CHANNEL_FETCH_LIST_BY_DEVICE";
export const CHANNEL_FETCH_LIST_BY_DEVICE_SUCCESS = "CHANNEL_FETCH_LIST_BY_DEVICE_SUCCESS";